import * as React from "react";
import { ModelPortfolioTabType } from "../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { ISearchProps } from "../../Resource/Content";
import { AdvancedSearch } from "../Shared/AdvancedSearch";
import { HubPortfolioSearch } from "./HubPortfolioSearch";

export const HubPortfolios = (props: ISearchProps) => {
    const query: InstrumentSearchQuery = {
        CanBeBought: true,
        ProductTypes: [ProductType.ModelPortfolio],
        ProductWrapperTypes: [props.type],
    };
    return (
        <div>
            <AdvancedSearch
                query={query}
                hiercharyId={props.hiercharyId}
                modelPortfolioType={ModelPortfolioTabType.HubModel}
            >
                <HubPortfolioSearch hiercharyId={props.hiercharyId} type={props.type} tableData={props.tableData} />
            </AdvancedSearch>
        </div>
    );
};
